module.exports = __webpack_public_path__ + "img/passenger-car.3b6d651.svg";